// action - state management
import * as actionTypes from './actions';

export const initialState = {
    success: false,
    loading: false,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const roleReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case actionTypes.FETCH_PERMISSION:
            return {
                ...state,
            };
        case actionTypes.SET_PERMISSION: {
            return {
                ...state,
                success: true,
                loading: false,
                payload: action
            };
        }
        default:
            return state;
    }
};

export default roleReducer;
